var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgWertgegenstaende = function SvgWertgegenstaende(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 86.408,
    height: 80.238
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "wertgegenstaende_svg__a",
    x1: 48.495,
    x2: 49.284,
    y1: 54.821,
    y2: -14.923,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ba722a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.098,
    stopColor: "#cd802d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.233,
    stopColor: "#e08d30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.392,
    stopColor: "#ed9632"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.596,
    stopColor: "#f59b34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f79d34"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#wertgegenstaende_svg__a",
    id: "wertgegenstaende_svg__d",
    x1: 34.499,
    x2: 43.447,
    y1: 59.494,
    y2: 16.858
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "wertgegenstaende_svg__e",
    x1: 40.733,
    x2: 24.584,
    y1: 33.252,
    y2: 40.112,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a3dee7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cbe9ef"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "wertgegenstaende_svg__b",
    x1: 19.29,
    x2: 8.704,
    y1: 43.155,
    y2: 45.652,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a3dee7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7bd3de"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "wertgegenstaende_svg__f",
    x1: 46.414,
    x2: 58.212,
    y1: 46.906,
    y2: 42.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a3dee7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#52c8d5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#wertgegenstaende_svg__b",
    id: "wertgegenstaende_svg__g",
    x1: 37.017,
    x2: 26.209,
    y1: 58.38,
    y2: 46.833
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "wertgegenstaende_svg__h",
    x1: 30.255,
    x2: 29.155,
    y1: 54.011,
    y2: 77.834,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#52c8d5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2abdcd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "wertgegenstaende_svg__c",
    x1: 43.225,
    x2: 50.625,
    y1: 66.502,
    y2: 53.775,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#01b2c4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2abdcd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#wertgegenstaende_svg__c",
    id: "wertgegenstaende_svg__i",
    x1: 25.095,
    x2: 9.482,
    y1: 75.03,
    y2: 54.016
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Ebene 2"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#wertgegenstaende_svg__a)",
    d: "M86.408 20.924a1.665 1.665 0 0 0-1.661-1.67L13.18 4.923a1.665 1.665 0 0 0-1.67 1.66l2.498 10.233 50.71 10.676a1.665 1.665 0 0 1 1.665 1.665s4.163 23.312 9.159 41.629c.745.957 3.33 1.665 4.162-2.498.619-3.092 3.992-27.765 5.687-40.259Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bcc8cc",
    d: "m19.423 1.291 7.114 45.356a1.12 1.12 0 0 0 .822.909l49.943 12.987a1.117 1.117 0 0 0 1.394-.986l3.957-45.83a1.117 1.117 0 0 0-.889-1.191L20.752.023a1.117 1.117 0 0 0-1.329 1.268"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d8dee2",
    d: "m12.125 4.38 10.643 45.3a1.12 1.12 0 0 0 .828.831l54.229 12.984a1.117 1.117 0 0 0 1.373-1.18L75.36 16.548a1.12 1.12 0 0 0-.889-1L13.437 3.03a1.117 1.117 0 0 0-1.312 1.35"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f4f4f8",
    d: "m6.332 8.958 14.165 45.244a1.12 1.12 0 0 0 .826.758L76.92 67.213a1.117 1.117 0 0 0 1.337-1.305l-8.783-44.993a1.12 1.12 0 0 0-.872-.88L7.623 7.53a1.117 1.117 0 0 0-1.29 1.428"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#wertgegenstaende_svg__d)",
    d: "m43.127 20.07.511 3.088-41.973-8.836A1.665 1.665 0 0 0 0 15.987L15.819 55.95a1.665 1.665 0 0 0 1.665 1.665l58.28 13.322-9.673-47.143a1.49 1.49 0 0 0-1.15-1.158L44.908 18.37a1.49 1.49 0 0 0-1.78 1.7"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f4f4f8",
    d: "m63.182 28.092-16.435-3.526a.745.745 0 0 1-.58-.61l-.395-2.451a.745.745 0 0 1 .899-.846l16.384 3.495a.75.75 0 0 1 .564.567l.447 2.483a.745.745 0 0 1-.884.888"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#wertgegenstaende_svg__e)",
    d: "M41.64 33.84H18.952L7.806 37.685l11.146 3.845H41.64l11.146-3.845z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#wertgegenstaende_svg__b)",
    d: "m11.702 53.123 7.25-11.593-11.146-3.845L0 45.134z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#wertgegenstaende_svg__f)",
    d: "M48.89 53.123 41.64 41.53l11.146-3.845 7.806 7.449z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#wertgegenstaende_svg__g)",
    d: "M11.702 53.123H48.89L41.64 41.53H18.952z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#wertgegenstaende_svg__h)",
    d: "M30.296 80.238 48.89 53.123H11.702z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#wertgegenstaende_svg__c)",
    d: "M60.592 45.134 48.89 53.123 30.296 80.238z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#wertgegenstaende_svg__i)",
    d: "m0 45.134 11.702 7.989 18.594 27.115z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M15.534 53.123c5.56-.26 11.119-.364 16.678-.388 2.78-.037 5.56-.015 8.339.01 2.78.006 5.559.06 8.339.132l-.209.376q-.88-1.465-1.725-2.952c-.569-.989-1.14-1.975-1.691-2.974.657.932 1.294 1.878 1.934 2.822q.967 1.41 1.899 2.844a.243.243 0 0 1-.197.375h-.011c-2.78.072-5.56.127-8.34.132-2.779.026-5.558.048-8.338.011-5.56-.024-11.118-.128-16.678-.388"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M55.812 48.397c-1.106.857-2.22 1.704-3.355 2.519-1.13.822-2.258 1.647-3.41 2.436l.072-.072-2.123 3.148-2.178 3.11c-.717 1.044-1.484 2.052-2.223 3.08a116 116 0 0 1-2.294 3.03 116 116 0 0 1 2-3.232c.692-1.06 1.357-2.139 2.07-3.183l2.118-3.152 2.172-3.115a.3.3 0 0 1 .072-.073c1.155-.785 2.334-1.536 3.512-2.289 1.172-.76 2.366-1.488 3.567-2.207M13.902 56.33c1.437 1.794 2.742 3.678 4.058 5.554 1.277 1.903 2.564 3.8 3.718 5.787-1.438-1.793-2.743-3.677-4.059-5.553-1.275-1.904-2.562-3.8-3.717-5.787"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M41.479 63.93c-7.426-.945-17.657-2.904-25.45-4.496l5.374 7.836a23.48 23.48 0 0 1 16.781 1.464ZM41.64 41.53H18.952l-7.25 11.593H14.9c10.134-5.646 21.73-7.904 28.495-8.788ZM11.702 53.123l7.25-11.593-1.945-.67A18.9 18.9 0 0 1 5.445 48.85Z",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M48.056 39.123c-2.125.84-4.24 1.705-6.373 2.522l-.02.008h-.023c-3.781.054-7.563.065-11.344.077l-11.344-.035.14-.077q-2.822 4.425-5.705 8.81 2.679-4.513 5.425-8.985l.047-.077h.093l11.344-.036c3.781.012 7.562.023 11.344.078l-.043.007c2.144-.787 4.307-1.526 6.46-2.292"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M40.332 33.84H23.003l6.483 7.69H41.64l4.009-1.383zM42.797 41.131l-1.157.4 7.25 11.592 8.145-5.56a23.86 23.86 0 0 1-14.238-6.432",
    opacity: 0.4
  }))));
};
export default SvgWertgegenstaende;